module.exports = __webpack_public_path__ + "static/media/yessir-this-guy-spittin.a9319d96.mp3";